import FullWidthPageHeader from './FullWidthPageHeader';

export default FullWidthPageHeader;
